//Items commented out were to please eslint and may be used once implemented

import React from 'react';
//import { Link } from 'react-router-dom';
import './myaccount.css';
import $ from 'jquery';
//import { format } from 'date-fns';
//import { useNavigate } from 'react-router-dom';

export default function MyAccount() {
	//const navigate = useNavigate();
	$(document).ready(function () {
		$(".admin-table").parents('div.admin-table-wrap').addClass("admin-table-data");
	});
	//const [filter, setFilter] = useState({ start: 1, length: 999, search: '', status: -1, sort: 0, user: true, isMyAccountPage: false });

    return (
        <div className="myaccount-table-center">
            <div className="product-header-wrap">
                <div>
                    <div className="product-breadcrumbs-wrap">
                        <p>
                            <a className="breadcrumb" href="/">Home</a><span>&nbsp;/&nbsp;</span>
                            <span>My Account</span>
                        </p>
                    </div>
                </div>
                <div className="product-main-title-wrap">
                    <h1 className="product-main-title">My Account</h1>
                    <a className="product-main-logout-button" href="/account/logout">Logout</a>
                </div>
            </div>
            <div className="my-account-btn">
                <a href="/">Go Home</a></div>
        </div>
    );
}


//function formatTimeWithAMPM(date) {
//	const inputDate = new Date(date);

//	const formattedTime = format(inputDate, 'hh:mma');
//	return formattedTime;
//}